document.addEventListener('DOMContentLoaded', function () {
  // Galerie produit : clic sur miniature
  document.querySelectorAll('.product__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelector('.product__gallery-main img').src = thumb.dataset.full;
      document.querySelectorAll('.product__thumbs img').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Sélecteur de variantes simple -> met à jour l'input caché du form
  document.querySelectorAll('.swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = sw.closest('.product__variants');
      group.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
      sw.classList.add('active');
      var select = document.getElementById(group.dataset.optionSelect);
      if (select) {
        select.value = sw.dataset.value;
        select.dispatchEvent(new Event('change'));
      }
    });
  });

  // Quantité
  document.querySelectorAll('.product__qty').forEach(function (qtyBox) {
    var input = qtyBox.querySelector('input');
    qtyBox.querySelector('.qty-minus').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || 1) - 1);
    });
    qtyBox.querySelector('.qty-plus').addEventListener('click', function () {
      input.value = parseInt(input.value || 1) + 1;
    });
  });

  // Ajout au panier en AJAX -> ouvre le drawer
  var addForm = document.getElementById('product-add-form');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(addForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(function () {
          return fetch('/cart.js').then(r => r.json());
        })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
          document.getElementById('cart-drawer').classList.add('is-open');
          var itemsWrap = document.getElementById('cart-drawer-items');
          if (itemsWrap) {
            itemsWrap.innerHTML = cart.items.map(function (it) {
              return '<div style="display:flex;gap:12px;margin-bottom:14px;">' +
                '<img src="' + it.image + '" style="width:60px;height:60px;object-fit:cover;border-radius:8px;">' +
                '<div><div style="font-weight:600;font-size:13.5px;">' + it.product_title + '</div>' +
                '<div style="font-size:12.5px;color:#777;">' + it.variant_title + ' · Qté ' + it.quantity + '</div></div></div>';
            }).join('');
          }
        })
        .catch(function () { addForm.submit(); });
    });
  }
});
